import {type Settings} from '../../../components/WorkspaceDrawer/Settings/types';
import * as DiscussionThreadNormalize from '../discussionThread/normalize';
import {type DenormFn, denormFn, normFn} from '../normalizerSupport';
import * as PanelSettingsNormalize from '../panelSettings/normalize';
import type * as Types from './types';

function normalizeReportLike<S extends Types.ReportLikeObjSchema>(
  type: S['type']
) {
  return normFn<S>(type, (whole, ctx) => ({
    version: whole.version,
    panelSettingsRef: PanelSettingsNormalize.normalize(
      // TODO(joyce) - remove this type assertion once settings are fully migrated
      whole.panelSettings as Settings,
      ctx
    ),
    blocks: whole.blocks,
    width: whole.width,
    authors: whole.authors,
    discussionThreadRefs: whole.discussionThreads.map(dt =>
      DiscussionThreadNormalize.normalize(dt, ctx)
    ),
  }));
}

type ReportDenormContext = Parameters<DenormFn<Types.ReportObjSchema>>[1];

const denormalizeReportPage = (
  part: Types.ReportPageNormalized,
  ctx: ReportDenormContext
): Types.ReportConfig => ({
  version: part.version,
  panelSettings: PanelSettingsNormalize.denormalize(part.panelSettingsRef, ctx),
  blocks: part.blocks,
  width: part.width,
  authors: part.authors,
  discussionThreads: part.discussionThreadRefs.map((dt, i) =>
    DiscussionThreadNormalize.denormalize(dt, ctx, i)
  ),
});

export const normalize = normalizeReportLike<Types.ReportObjSchema>('runs');
export const normalizeCollectionOverview =
  normalizeReportLike<Types.CollectionOverviewObjSchema>('collection-overview');
export const normalizeCollectionOverviewDraft =
  normalizeReportLike<Types.CollectionOverviewDraftObjSchema>(
    'collection-overview/draft'
  );

export const denormalize = denormFn<Types.ReportObjSchema>(
  denormalizeReportPage
);
export const denormalizeCollectionOverview =
  denormFn<Types.CollectionOverviewObjSchema>(denormalizeReportPage);
export const denormalizeCollectionOverviewDraft =
  denormFn<Types.CollectionOverviewDraftObjSchema>(denormalizeReportPage);
